import { render, staticRenderFns } from "./DsalesIndex.vue?vue&type=template&id=5d6e133c&scoped=true"
import script from "./DsalesIndex.vue?vue&type=script&lang=js"
export * from "./DsalesIndex.vue?vue&type=script&lang=js"
import style0 from "./DsalesIndex.vue?vue&type=style&index=0&id=5d6e133c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6e133c",
  null
  
)

export default component.exports